<div #ssChartContainer class="ss-chart-container">
    <highcharts-chart *ngIf="chartOptions"  [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>
</div>
